var map = {
	"./Cloth1": [
		"c544",
		"chunk-2d216f28"
	],
	"./Cloth1.vue": [
		"c544",
		"chunk-2d216f28"
	],
	"./ClothLoader": [
		"b211"
	],
	"./ClothLoader.vue": [
		"b211"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2d14";
module.exports = webpackAsyncContext;